import { Vue, Component, Prop } from 'vue-property-decorator'
import { api } from '@/galaxy-cruise/api';
import moment from 'moment'
import { reloadMessages } from '@/galaxy-cruise/utils';
import { IMessage } from '@/galaxy-cruise/api_interface';

@Component
export default class extends Vue {
  @Prop()
  message?: IMessage

  ja_title = this.message && this.message.ja_title || ''
  en_title = this.message && this.message.en_title || ''
  ja_html = this.message && this.message.ja_html || ''
  en_html = this.message && this.message.en_html || ''
  published_at = this.message && this.message.published_at || moment().toISOString()

  async submit() {
    const axios = api.default
    const { ja_html, ja_title, en_title, en_html, published_at } = this
    const message = {
      ja_title, ja_html,
      en_title, en_html,
      published_at,
    }
    if (this.message) {
      await axios.put(`../api/v1/messages/${this.message.id}`, { message })
    } else {
      await axios.post('../api/v1/messages', { message })
    }
    await reloadMessages()
    this.$emit('resolve')
  }
}
